import React, { useState, useEffect } from "react";
import EnquiryPackageModal from "./EnquiryPacking/EnquiryPackageModal";
import masterServices from "../../../Services/masterService";
import { toast } from "react-toastify";
import EnquiryHelper from "./EnquiryHelper";
import EnquiryService from "../../../Services/EnquiryService";
import Loader from "../../../Components/Loader";
import { Form } from "react-bootstrap-v5";


const EnquiryAddOns = (props) => {

  const { detaildata, DestinationValue, OrginValue, setStorageValue, storageValue, selectedValue, deliverytotal, deliveryInitial, setInsuranceValue, insuranceValue, quotedData, setFinalFreightAmount, setTotalpackingCharge, setPackingChargeAmount, setPackingJson, setFreightCharge, setSpinner, discount, percentage, settingDiscount, setSubTotalInit, itemGoods, userFreight, getDetail, setPackingwithService, packingwithService, insuranceData,packingJson } = props;

  const [loader, setLoader] = useState(false);
  const [storageData, setStorageData] = useState();
  const [show, setShow] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  // all listing api"s
  const getStorageList = async () => {
    await masterServices.get_storage().then((result) => {
      if (result.status === true) {
        setStorageData(result.data.storages);
        if (storageValue?.minimum) storageValue.minimum = result.data.minimum;
        if (Array.isArray(result.data.storages)) {
          // eslint-disable-next-line
          result.data.storages.map((item, key) => {
            if (item.tarrif === "storage_charges") {
              if (storageValue) storageValue.storage_charges = item.rate;
            }
            if (item.tarrif === "handling_in") {
              if (storageValue) storageValue.handling_in = item.rate;
            }
            if (item.tarrif === "handling_out") {
              if (storageValue) storageValue.handling_out = item.rate;
            }
          });
        }
      }
    });
  };

  // common useeffect
  useEffect(() => {
    getStorageList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // let addOnsPacking = getDetail?.quote_request_items[0]
    insuranceValue?.insurance_amount ? setIsSwitchOn(true) : setIsSwitchOn(false)
  }, [insuranceValue?.insurance_amount])

  const packingShow = () => {
    if (!selectedValue) {
      setShow(false);
      toast.info("Service field is required, please check");
    } else {
      setShow(true);
    }
  };


  //// Insurance Function

  const insuranceHandler = (flag) => {
    let uFreight = quotedData ? quotedData : userFreight
    let freightAmount = 0;
    let value = flag ? insuranceValue.items_goods : null
    let insuranceResult;
    if (detaildata && uFreight) {

      insuranceResult = EnquiryHelper.insuranceCalculation(
        uFreight,
        value,
        insuranceData
      );
    }

    if (!value) {
      setInsuranceValue({
        ...insuranceValue,
        insurance_amount: 0,
      });
      freightAmount = EnquiryHelper.subTotalfun(packingwithService || deliveryInitial, 0, storageValue.storage_amount);
      setSubTotalInit(freightAmount)
    } else {
      if (insuranceResult <= 150) {
        setInsuranceValue({
          ...insuranceValue,
          insurance_amount: 150,
        });
        freightAmount = EnquiryHelper.subTotalfun(packingwithService || deliveryInitial, 150, storageValue.storage_amount);
        setSubTotalInit(freightAmount)
      } else {
        setInsuranceValue({
          ...insuranceValue,
          insurance_amount: Number(insuranceResult),
        });
        freightAmount = EnquiryHelper.subTotalfun(packingwithService || deliveryInitial,
          Number(insuranceResult),
          storageValue.storage_amount
        );
        setSubTotalInit(freightAmount)
      }
    }
    let discountAmt = EnquiryHelper.getDiscountbyPercentage(percentage, freightAmount)
    settingDiscount(discountAmt.toFixed(2))
    let finalAmount = (freightAmount - discountAmt.toFixed(2) || discount)
    setFinalFreightAmount(finalAmount.toFixed(2))
  };

  //// Storage Function

  const storageHandler = (e) => {
    const { value } = e.target;
    let freightAmount = 0;
    let storageResult;
    if (value && value > 0) {
      storageResult = EnquiryHelper.storageCalculation(
        value,
        storageData,
        detaildata
      );
      if (!storageResult) {
        // storageValue.storage_amount = 0;
        // storageValue.storage_value = value;
        setStorageValue({
          ...storageValue,
          storage_amount: 0,
          storage_value: value,
        });
      } else if (storageResult <= 100) {
        // storageValue.storage_amount = 100;
        // storageValue.storage_value = value;
        setStorageValue({
          ...storageValue,
          storage_amount: 100,
          storage_value: value,
        });
        freightAmount = EnquiryHelper.subTotalfun(packingwithService || deliveryInitial, insuranceValue.insurance_amount, 100);
        setSubTotalInit(freightAmount)
      } else {
        // storageValue.storage_amount = Math.round(storageResult);
        // storageValue.storage_value = value;
        setStorageValue({
          ...storageValue,
          storage_amount: Math.round(storageResult),
          storage_value: value,
        });
        freightAmount = EnquiryHelper.subTotalfun(
          packingwithService || deliveryInitial,
          insuranceValue.insurance_amount,
          Math.round(storageResult)
        );
        setSubTotalInit(freightAmount)
      }

    } else {
      freightAmount = EnquiryHelper.subTotalfun(packingwithService || deliveryInitial, insuranceValue.insurance_amount, 0);
      // storageValue.storage_value = value;
      setStorageValue({
        ...storageValue,
        storage_value: value,
        storage_amount: 0
      });
      setSubTotalInit(freightAmount)
    }
    let discountAmt = EnquiryHelper.getDiscountbyPercentage(percentage, freightAmount)
    settingDiscount(discountAmt.toFixed(2))
    let finalAmount = (freightAmount - discountAmt.toFixed(2) || discount)
    setFinalFreightAmount(finalAmount.toFixed(2))
  };

  //// function for packing calculation

  const updatePacking = (packingdata) => {
    if (packingdata) {
      const packingChargeOnly = packingdata.freight + packingdata.charges;
      let freightAmount = EnquiryHelper.subTotalfun(
        packingChargeOnly,
        insuranceValue.insurance_amount,
        storageValue.storage_amount
      );
      const finalPackingCharge = Number(deliveryInitial) + freightAmount;
      setSubTotalInit(finalPackingCharge)
      const servicepackAmt = Number(packingChargeOnly) + Number(deliveryInitial)
      setPackingwithService(servicepackAmt)
      setPackingChargeAmount(packingChargeOnly);
      setTotalpackingCharge(finalPackingCharge);
      setFreightCharge(packingdata.freight)
      let discountAmt = EnquiryHelper.getDiscountbyPercentage(percentage, finalPackingCharge)
      settingDiscount(discountAmt.toFixed(2))
      let finalAmount = Number(finalPackingCharge) - Number(discountAmt.toFixed(2))
      setFinalFreightAmount(finalAmount.toFixed(2))

      let postItem = {
        items: packingdata.packing,
        quote_token: detaildata && detaildata.quote_token,
      };

      setLoader(true);
      EnquiryService.updatePackingApi(postItem)
        .then((res) => {
          if (res.status === true) {
            setLoader(false);
            setShow(false);
            let packdata = packingdata.packing;
            setPackingJson(packdata);
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const packingClose = () => {
    setShow(false)
  }

  const onSwitchAction = (e) => {

    if (selectedValue) {
      if (e.target.checked) {
        setIsSwitchOn(true);
        insuranceHandler(true)
      } else {
        setIsSwitchOn(false);
        insuranceHandler(false)
      }
    } else {
      toast.info("Please select a service first")
    }
  };

  return (
    <div className="tab-pane fade show" id="addonsInfo" rol="tabpanel">
      <section className="sectionBorder mt-3">
        <div className="card-header custom_header">
          <h5>Add ons</h5>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="mb-3 col-4">
              <label className="form-label">Packing</label>
              <div>
                <button
                  className="btn btn-primary w-sm w-100"
                  type="button"
                  onClick={() => packingShow()}
                >
                  Add & View Packing
                </button>
              </div>
            </div>

            <div className="mb-3 col-4">
              <label className="form-label">Insurance</label>
              <input
                readOnly={itemGoods ? true : isSwitchOn ? true : false}
                className="form-control"
                type="text"
                value={insuranceValue.items_goods}
                placeholder="Enter Insurance"
                onChange={(e) => setInsuranceValue({
                  ...insuranceValue,
                  items_goods: e.target.value
                })}
              />
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label="Select if Insurance require"
                  checked={isSwitchOn}
                  onChange={(e) => onSwitchAction(e)}
                />

              </Form>
            </div>

            <div className="mb-3 col-4">
              <label className="form-label">Storage</label>
              <input
                className="form-control"
                type="number"
                value={storageValue?.storage_value}
                placeholder="Enter Storage"
                onChange={(e) => storageHandler(e)}
                readOnly={selectedValue ? false : true}
              />
            </div>
          </div>
        </div>
      </section>

      <EnquiryPackageModal
        isShow={show}
        onHide={packingClose}
        // SinglePacking={singlePackingChangeHandler}
        // AllPacking={allPackingChangeHandler}
        originData={OrginValue}
        destinationData={DestinationValue}
        volumestate={detaildata}
        serviceType={selectedValue}
        serviceAmount={deliverytotal ? deliverytotal : deliveryInitial}
        saveHandle={(e) => updatePacking(e)}
        settingSpin={setSpinner}
        getDetail={getDetail}
        packingJson={packingJson}
      />



      <Loader
        isShow={loader}
      />
    </div>
  );
};

export default React.memo(EnquiryAddOns);